import React from "react";
import Button from "@mui/material/Button";
import { SvgIcon } from "Components/SvgIcon";
import Menu from "@mui/material/Menu";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { SettingsDialog } from "./SettingsDialog";
import { LayoutSettingsDialog } from "./LayoutSettingsDialog";
import { ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
/* import { ConferenceContext } from 'pages/AntMedia'; */
import { ConferenceContext } from "Views/pages/NewWebRtcAdaptor";
import { useSelector } from "react-redux";

const CustomizedBtn = styled(Button)(({ theme }) => ({
  "&.footer-icon-button": {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: 8,
      minWidth: "unset",
      width: "100%",
      "& > svg": {
        width: 36,
      },
    },
  },
}));

function OptionButton({ footer, user,  ...props }) {
  const conference = React.useContext(ConferenceContext);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [layoutDialogOpen, setLayoutDialogOpen] = React.useState(false);
  
  const dataLanding = useSelector(state => state.landingData.landing)

  const buttonClasses = `bg-[#292D46] rounded-full p-1 flex items-center justify-center ${
    footer ? "w-14 h-14 sm:w-10 sm:h-10" : ""
  } shadow-md`;

  // if you select camera then we are going to focus on camera button.
  const [selectFocus, setSelectFocus] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDialogOpen = (focus) => {
    setSelectFocus(focus);
    setDialogOpen(true);
    handleClose();
  };

  const handleDialogClose = (value) => {
    setDialogOpen(false);
  };
  const handleLayoutDialogOpen = (focus) => {
    setSelectFocus(focus);
    setLayoutDialogOpen(true);
    handleClose();
  };

  const handleLayoutDialogClose = (value) => {
    setLayoutDialogOpen(false);
  };
  
  const styleButton = {
    "backgroundColor":dataLanding?.color_primary
  }

    return (
        <>
          <SettingsDialog
              open={dialogOpen}
              onClose={handleDialogClose}
              selectFocus={selectFocus}
              user={user}
          />
          <LayoutSettingsDialog
              open={layoutDialogOpen}
              onClose={handleLayoutDialogClose}
              selectFocus={selectFocus}
          />
          <Tooltip title={t("More options")} placement="top">
            <button
                className={buttonClasses}
                id="demo-positioned-button"
                color={open ? "primary" : "secondary"}
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                style={styleButton}
            >
              <SvgIcon size={40} name={'settings'} color={open ? 'black' : 'white'} />
            </button>
          </Tooltip>
          <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
          >
           {/*  <MenuItem onClick={() => handleLayoutDialogOpen()}>
              <ListItemIcon>
                <SvgIcon size={36} name={"layout"} color={"white"} />
              </ListItemIcon>
              <ListItemText>{t("Change Layout")}</ListItemText>
            </MenuItem> */}

              {conference.isPlayOnly === false ?
            <MenuItem onClick={() => handleDialogOpen()}>
              <ListItemIcon>
                <SvgIcon size={36} name={"call-settings"} color={"white"} />
              </ListItemIcon>
              <ListItemText>{t("Call Settings")}</ListItemText>
            </MenuItem>
                    : null}

          
          </Menu>
        </>
    );
}

export default OptionButton;
